export default __webpack_public_path__ + "partner_4a9a8c6.png";